import React from 'react';
import Article from '../../Article/Article';

export default function ArticlePage({ get_article_endpoint }) {
	return (
		<div className="container p-4 pt-4 lg:py-14 md:px-20">
			<div className="mt-4">
				<div className="grid grid-cols-1">
					<Article get_article_endpoint={get_article_endpoint} />
				</div>
			</div>
		</div>
	);
}
